import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterTipoEmpleadoModel } from 'src/app/models/interfaces/tipo-empleado/IFilterTipoEmpleadoModel';
import { ITipoEmpleadoModel } from 'src/app/models/interfaces/tipo-empleado/ITipoEmpleadoModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TipoEmpleadoService {

  private configUrl = [environment.apiGatewayUrl, 'tipos-empleado'].join('/');
  constructor(private http: HttpClient) { }

  getListFiltered(
    model: IFilterTipoEmpleadoModel
    ) : Observable<SearchResultModel<ITipoEmpleadoModel[]>> {
    let queryParams: string[] = new Array<string>();

    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    queryParams.push(`idEstado=${model.idEstado}`);
    
    if (model.nombre !== '') {
      queryParams.push(`nombre=${model.nombre}`);
    }

    return this.http.get<SearchResultModel<ITipoEmpleadoModel[]>>(
      `${this.configUrl}/filtrar?${queryParams.join('&')}`
    );
  }

  getAllList(
    model: IFilterTipoEmpleadoModel
    ) : Observable<ITipoEmpleadoModel[]> {
    let queryParams: string[] = new Array<string>();

    // queryParams.push(`page=${model.page}`);
    // queryParams.push(`take=${model.pageSize}`);

    return this.http.get<ITipoEmpleadoModel[]>(
      `${this.configUrl}/all?${queryParams.join('&')}`
    );
  }

  getById(id: number): Observable<ITipoEmpleadoModel> {
    return this.http.get<ITipoEmpleadoModel>(`${this.configUrl}/${id}`);
  }

  submit(model: ITipoEmpleadoModel) {
    return this.http.post<ITipoEmpleadoModel>(`${this.configUrl}`, model);
  }

  update(model: ITipoEmpleadoModel) {
    return this.http.put<ITipoEmpleadoModel>(
      `${this.configUrl}/${model.idTipoEmpleado}`,
      model
    );
  }

  delete(id: number) {
    return this.http.delete<ITipoEmpleadoModel>(`${this.configUrl}/${id}`);
  }
}
